import { c as _c } from "react/compiler-runtime";
import "@/styles/fonts.css";
import "@/styles/globals.css";
import Layout from "@/components/layout/Layout";
import Head from "next/head";
export default function App(t0) {
  const $ = _c(4);
  const {
    Component,
    pageProps
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Head><meta name="viewport" content="width=device-width, initial-scale=1" /><link rel="icon" href="/girmitiya-logo.ico" sizes="any" /><link rel="icon" href="/brand/girmitiya-logo.webp" type="image/webp" /><link rel="apple-touch-icon" href="/girmitiya-logo.ico" /></Head>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== Component || $[2] !== pageProps) {
    t2 = <>{t1}<Layout><Component {...pageProps} /></Layout></>;
    $[1] = Component;
    $[2] = pageProps;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}